import { css } from '@emotion/react';
import { Tooltip } from './tooltip';
import ArrowUpCircleSVG from '@birdi/icons/arrow-up-circle.svg';
import { TooltipProvider } from '@radix-ui/react-tooltip';

interface UpgradeIndicatorProps {
  message: string;
}

const getPublicTokens = () => {
  let publicToken = undefined;
  let mapId = undefined;

  if (typeof window !== 'undefined') {
    // Extract token from query parameters
    const urlParams = new URLSearchParams(window.location.search);
    publicToken = urlParams.get('token');

    // Extract mapId from URL path if on a map page
    const pathname = window.location.pathname;
    const mapPathRegex = /\/map\/next\/([0-9a-f-]+)/;
    const match = pathname.match(mapPathRegex);
    if (match && match[1]) {
      mapId = match[1];
    }
  }

  return { publicToken, mapId };
};

export const UpgradeIndicator = ({ message }: UpgradeIndicatorProps) => {
  const { publicToken, mapId } = getPublicTokens();
  const displayUpgradeIndicator = !publicToken;

  return (
    <>
      {displayUpgradeIndicator && (
        <TooltipProvider>
          <Tooltip
            trigger={
              <div
                css={css`
                  display: flex;
                  align-items: center;
                `}
                onClick={(e) => e.stopPropagation()}
              >
                {/* @ts-ignore - SVG and CSS prop type error */}
                <ArrowUpCircleSVG
                  css={(theme) => css`
                    color: ${theme.sunConure};
                  `}
                  data-testid="upgrade-indicator-icon"
                />
              </div>
            }
          >
            {message}
          </Tooltip>
        </TooltipProvider>
      )}
    </>
  );
};
